'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseDropdown = require('@bibliocommons/base-dropdown');

var _baseButtons = require('@bibliocommons/base-buttons');

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

require('../styles/ComboButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function ComboButton(_ref) {
  var options = _ref.options,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$btnClass = _ref.btnClass,
      btnClass = _ref$btnClass === undefined ? '' : _ref$btnClass,
      _ref$secondaryAriaLab = _ref.secondaryAriaLabel,
      secondaryAriaLabel = _ref$secondaryAriaLab === undefined ? '' : _ref$secondaryAriaLab,
      _handleClick = _ref.handleClick,
      labelledById = _ref.labelledById,
      label = _ref.label,
      _ref$right = _ref.right,
      right = _ref$right === undefined ? true : _ref$right,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === undefined ? false : _ref$isLoading,
      _ref$ButtonTag = _ref.ButtonTag,
      ButtonTag = _ref$ButtonTag === undefined ? _baseButtons.DefaultButton : _ref$ButtonTag,
      children = _ref.children,
      disabled = _ref.disabled,
      _ref$dataKey = _ref.dataKey,
      dataKey = _ref$dataKey === undefined ? '' : _ref$dataKey;

  var _options = _toArray(options),
      primary = _options[0],
      secondary = _options.slice(1);

  return _react2.default.createElement(
    'div',
    { className: 'cp-combo-button btn-group ' + className },
    _react2.default.createElement(
      ButtonTag,
      {
        disabled: disabled,
        className: btnClass,
        isLoading: isLoading,
        handleClick: function handleClick() {
          return _handleClick(primary.value);
        },
        'data-key': dataKey },
      primary.label,
      children
    ),
    _react2.default.createElement(_baseDropdown.Dropdown, {
      ButtonTag: ButtonTag,
      right: right,
      selected: _react2.default.createElement(
        _baseScreenReaderMessage2.default,
        null,
        secondaryAriaLabel
      ),
      disableMobile: true,
      disabled: disabled || isLoading,
      options: secondary,
      handleSelect: _handleClick,
      labelledById: labelledById,
      labelLocalizedText: label,
      descriptionLocalizedText: label })
  );
}

exports.default = ComboButton;
ComboButton.displayName = 'ComboButton';

ComboButton.propTypes = {
  children: _bcPropTypes.childrenShape,
  ButtonTag: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_baseBcReactComponent2.default), _react.PropTypes.func]),
  right: _react.PropTypes.bool,
  disabled: _react.PropTypes.bool,
  options: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    label: _react.PropTypes.node,
    value: _react.PropTypes.any
  })).isRequired,
  btnClass: _react.PropTypes.string,
  handleClick: _react.PropTypes.func.isRequired,
  labelledById: _react.PropTypes.string,
  label: _react.PropTypes.string,
  className: _react.PropTypes.string,
  isLoading: _react.PropTypes.bool,
  secondaryAriaLabel: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string.isRequired]),
  dataKey: _react.PropTypes.string
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-combo-button/lib/components/ComboButton.component.js
// module id = 1059
// module chunks = 1